import { Canales } from './canales';
import { ProductoPrecio } from './productoPrecio';
import { Unidades } from './unidades';

export class Producto {
    codigo: number;
    codigoPrincipal: string;
    codigoAuxiliar: string;
    nombre: string;
    valorUnitario: number;
    valorCaja:  number;
    valorLibra:  number;
    tipoProducto: string;
    iva: string;
    ice: string;
    irbpnr: string;
    idEmisor: number;
    total:number;
    cantidad:number;
    idUnidad:number ;
    unidadesVenta:  Unidades[]= [];
    factor: number;
    valorIva:number;
    tipoId: number;
    costo: number;
    desc:number;
    valdesc:number;
    precioDesc:number;
    grupo:string;
    stock:number;
    utilidad:number;
    marca:string;    
    color:string;
    orden:number;
    enviado:string;
    imagen:string;
    productoTerminado:boolean;
    ordenar:number;
    selectUnidad:string;
     lote:string;
     idLote:number;
      canalesLista:  Canales[]= [];
      listaProductoPrecio: ProductoPrecio[];
    }
    